function initDistances() {
	
	
	const form = document.querySelector('form.distance');
	if(!form) return;
	
	const debounce_delay = 250;
	const button = form.querySelector('button');
	const inputs = form.querySelectorAll('form.distance input');
	
	inputs.forEach((input) => {
		
		const wrapper = document.createElement('div');
		wrapper.classList.add('wrapper');
		input.parentNode.insertBefore(wrapper, input);
		wrapper.appendChild(input);
		
		const results = document.createElement('ul');
		results.classList.add('results');
		wrapper.append(results);
		
		let timer = null;
		let controller = null;
		
		function autocomplete() {
			clearTimeout(timer);
			
			if(controller) {
				controller.abort();
				controller = null;
			}
			
			const q = input.value.trim();
			if(q.length < 1) {
				results.style.display = 'none';
				return;
			}
			
			timer = setTimeout(async () => {
				
				controller = new AbortController();
				
				try {
					const response = await fetch('/api/search.php?type=pc&q='+encodeURIComponent(q), {
						signal: controller.signal,
						headers: {
							'Accept': 'application/json'
						}
					});
					if(!response.ok) {
						throw new Error('HTTP '+response.status);
					}
					const data = await response.json();
					if(!Array.isArray(data)) {
						throw new Error('Unexpected response');
					}
					
					if(data.length > 0) {
						results.innerHTML = '';
						data.forEach((item)=>{
							const li = document.createElement('li');
							results.append(li);
							const a = document.createElement('a');
							a.innerHTML = item.name;
							a.setAttribute('href', '#');
							a.addEventListener('click', (e)=>{
								e.preventDefault();
								input.value = item.name;
								if([...inputs].indexOf(input) === 0) inputs[1].focus();
								else button.focus();
								results.style.display = 'none';
							});
							
							// up down key nav
							a.addEventListener('keydown', (e)=>{
								let first = (a.parentElement === a.parentElement.parentElement.firstElementChild);
								let last = (a.parentElement === a.parentElement.parentElement.lastElementChild);
								if(e.key === 'ArrowDown') {
									e.preventDefault();
									if(!last) a.parentElement.nextElementSibling.querySelector('a').focus();
									return;
								}
								if(e.key === 'ArrowUp') {
									e.preventDefault();
									if(first) input.focus();
									else a.parentElement.previousElementSibling.querySelector('a').focus();
									return;
								}
							});
							
							li.append(a);
							
						});
						results.style.display = 'block';
					}
					else {
						results.style.display = 'none';
					}
					
				} catch (error) {
					if(error.name !== 'AbortError') {
						console.error('Autocomplete error: '+error);
					}
				}
				
			}, debounce_delay);
		}
		
		input.addEventListener('input', autocomplete);
		input.addEventListener('focus', autocomplete);
		
		// tab focus to results if pressing down key
		input.addEventListener('keydown', (e)=>{
			if(e.key === 'ArrowDown') {
				e.preventDefault();
				let firstResult = results.querySelector('a');
				if(firstResult) firstResult.focus();	
			}
		});
		
		// close with esc
		document.addEventListener('keydown', (e)=>{
			if(e.key === 'Escape') {
				results.style.display = 'none';
			}
		});
		
		// close with click outside
		document.addEventListener('click', (e) => {
			if(results.style.display === 'block') {
				if(!results.contains(e.target)) {
					results.style.display = 'none';
				}
			}
		});
		
		// close when focus leaves parent
		wrapper.addEventListener('focusout', (e)=>{
			const next = e.relatedTarget;
			if(!wrapper.contains(next)) {
				results.style.display = 'none';
			}
		});
		
		// remove error states
		input.addEventListener('focus', (e) => {
			input.removeAttribute('aria-invalid');
		});
		
	});
	
	
	form.addEventListener('submit', (e)=>{
		e.preventDefault();
		let valid = true;
		inputs.forEach((input) => {
			q = input.value.trim().toUpperCase();
			q = q.replace(/\s+/g, ' ');
			q = q.replace(/[^A-Z0-9 ]/gi, "");
			input.dataset.sanitised = q;
			if((q.length < 2) || (q.length > 8)) {
				input.setAttribute('aria-invalid', 'true');
				valid = false;
			}
			else input.removeAttribute('aria-invalid');
		});
		if(valid) {
			let url = '/distance?from='+encodeURIComponent(inputs[0].dataset.sanitised)+'&to='+encodeURIComponent(inputs[1].dataset.sanitised);
			window.location.href = url;
		}
	})
	
	
	

}
initDistances();

  